module.exports = __webpack_public_path__ + "img/m_icn_lang.c502287a.svg";